import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import router from '../router/index'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'sh_admin_vuex',
  storage: window.localStorage
});

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});
http.interceptors.request.use(
  (config) => {
    if(store.state.access_token) config.headers['Authorization'] = 'Bearer ' + store.state.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if(error.response.status == 401 && !store.state.route.fullPath.match(/^\/auth(\/.*)?$/)) {
      store.dispatch('logoutUser', true);
    }
    return Promise.reject(error);
  }
)

const cache = {};

const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    access_token: false,
    user: {
      updated: 0,
      data: {}
    },
    settings: {
      'navMini': false,
      'authorized': false
    },
    cache: JSON.parse(JSON.stringify(cache))
  },
  getters: {
    user (state) {
      return (state.user.data.id ? state.user.data : false)
    },
    userCan (state, getters) {
      return function(permission) {
        if(!permission || !getters.user || !getters.user.auth || !getters.user.auth.permissions) return false;
        if(getters.user.auth.permissions.indexOf(permission) >= 0) return true;
        return false;
      }
    },
    userIs (state, getters) {
      return function(role) {
        if(!role || !getters.user || !getters.user.auth || !getters.user.auth.roles) return false;
        if(getters.user.auth.roles.indexOf(role) >= 0) return true;
        return false;
      }
    },
    isAuthorized: function(state, getters) {
      return (state.access_token && getters.user ? true : false)
    },
    setting (state) {
      return function(setting) {
        return state.settings[setting];
      }
    }
  },
  actions: {
    loginUser ( context, data ) {
      if(!data || !data.access_token || !data.user || !data.user.id) return;
      context.commit('setUser', data.user);
      context.commit('setToken', data.access_token);
      if(router.history.current.query && router.history.current.query.redirect) {
        router.push({path: router.history.current.query.redirect});
      } else {
        router.push({name: 'dashboard'})
      }
    },
    logoutUser ( context, redirect ) {
      let query = {};
      if(redirect) {
        if(!router.history.current.fullPath.match(/^\/auth(\/.*)?$/) && router.history.current.name != 'dashboard') {
          query.redirect = router.history.current.fullPath;
        }
      }

      context.commit('setToken');
      context.commit('setUser');
      router.push({name: 'auth', query: query});
    },
    checkForUpdates ( context, force ) {
      if(context.getters.isAuthorized) {
        if(force || (context.state.user.updated + 300000) < Date.now() ) {
          context.dispatch('checkForUserUpdates');
        }
      }
    },
    checkForUserUpdates (context) { 
      return new Promise((resolve, reject) => {
        http.get('auth')
          .then(response => {
            context.commit('setUser', response.data.user);
            resolve(response.data.user);
          })
          .catch(err => {
            if(!err.response || err.response.status == 401) return;
            context.dispatch('logoutUser', true);
            reject(err);
          })
      });
    }
  },
  mutations: {
    setSetting( state, data ) {
      if(!data.name) return;
      state.settings[data.name] = data.value;
    },
    setToken( state, token ) {
      if(!token || token == '') token = false;
      state.access_token = token;
    },
    setUser( state, data ) {
      if(!data || !data.id) data = {};
      state.user.updated = (!data.id ? 0 : Date.now());
      state.user.data = data;
    },
    resetCaches( state ) {
      state.cache = JSON.parse(JSON.stringify(cache));
    }
  }
});

export default store;
